'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { Box } from '@s7/base';
import { useUncontrolled, useId } from '@s7/hooks';
import { useComponentDefaultProps } from '@s7/styles';
import { CheckboxGroupProvider } from './CheckboxGroup.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultProps = {
    size: "sm1"
};
var CheckboxGroup = /*#__PURE__*/ forwardRef(function(props, ref) {
    var _useComponentDefaultProps = useComponentDefaultProps("CheckboxGroup", defaultProps, props), theme = _useComponentDefaultProps.theme, children = _useComponentDefaultProps.children, value = _useComponentDefaultProps.value, defaultValue = _useComponentDefaultProps.defaultValue, onChange = _useComponentDefaultProps.onChange, size = _useComponentDefaultProps.size, color = _useComponentDefaultProps.color, position = _useComponentDefaultProps.position, name = _useComponentDefaultProps.name, disabled = _useComponentDefaultProps.disabled, spacing = _useComponentDefaultProps.spacing, required = _useComponentDefaultProps.required, readOnly = _useComponentDefaultProps.readOnly, transitionDuration = _useComponentDefaultProps.transitionDuration, error = _useComponentDefaultProps.error, others = _object_without_properties_loose(_useComponentDefaultProps, [
        "theme",
        "children",
        "value",
        "defaultValue",
        "onChange",
        "size",
        "color",
        "position",
        "name",
        "disabled",
        "spacing",
        "required",
        "readOnly",
        "transitionDuration",
        "error"
    ]);
    var _useUncontrolled = useUncontrolled({
        value: value,
        defaultValue: defaultValue,
        finalValue: [],
        onChange: onChange
    }), _value = _useUncontrolled[0], setValue = _useUncontrolled[1];
    var handleChange = function(event) {
        var itemValue = event.currentTarget.value;
        setValue(_value.includes(itemValue) ? _value.filter(function(item) {
            return item !== itemValue;
        }) : [].concat(_value, [
            itemValue
        ]));
    };
    var _name = useId(name);
    return /*#__PURE__*/ jsx(CheckboxGroupProvider, {
        value: {
            value: _value,
            name: _name,
            onChange: handleChange,
            theme: theme,
            transitionDuration: transitionDuration,
            required: required,
            readOnly: readOnly,
            position: position,
            disabled: disabled,
            spacing: spacing,
            color: color,
            size: size,
            error: error
        },
        children: /*#__PURE__*/ jsx(Box, _extends({
            ref: ref
        }, others, {
            children: children
        }))
    });
});
CheckboxGroup.displayName = "Checkbox.Group";

export { CheckboxGroup };
